import {
  Alert,
  Backdrop,
  Box,
  CircularProgress,
  Container,
  Grid,
  Icon,
  Snackbar,
  Typography,
  Button,
  Divider,
  // TextField,
  Stepper,
  Step,
  StepLabel,
  Stack,
  // CardContent,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  TextField,
  MenuItem,
  FormControl,
  InputAdornment,
  IconButton,
  Paper,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useGeolocated } from "react-geolocated";
import QRCode from "react-qr-code";
import CheckoutFooter from "../../components/footer";
import AppConfig from "../../../appConfig";
import axios from "../../../axios";
import FormSectionBuilder from "../../components/data_forms/form_section_builder";
import usePageTitle from "../../pageTitle";
import { useNavigate, useParams } from "react-router-dom";
import GoogleAddressField from "../../components/google_address";

function BuyPage() {
  const [pageTitle, setPageTitle] = useState("Checkout");
  usePageTitle(pageTitle);

  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("error");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [openCopySnackBar, setOpenSnackBar] = useState(false);
  async function copy(stringtext) {
    console.log(stringtext);
    try {
      await navigator.clipboard.writeText(stringtext);
      setOpenSnackBar(true);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  }

  const [steps, setSteps] = useState(["Payment Information", "Process Order"]);

  const [activeStep, setActiveStep] = useState(0);
  const [products, setProducts] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0.0);

  const [banner, setBanner] = useState(null);
  const [webStore, setWebStore] = useState(null);
  const [campaign, setCampaign] = useState(null);
  const [currency, setCurrency] = useState("N");
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [campaignPaymentMethods, setCampaignPaymentMethods] = useState([]);
  const [showPaymentMethods, setShowPaymentMethods] = useState(false);
  const [shippingRequired, setShippingRequired] = useState(false);

  const [dataForm, setDataForm] = useState(null);
  const [dataFormSections, setDataFormSections] = useState([]);
  const [dataFormValues, setDataFormValues] = useState(null);

  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [emailAddress, setEmailAddress] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);

  const [shippingRate, setShippingRate] = useState(null);
  const [shippingStates, setShippingStates] = useState([]);
  const [shippingStateOptions, setShippingStateOptions] = useState([]);
  const [selectedShippingState, setSelectedShippingState] = useState(null);
  const [selectedShippingStateOption, setSelectedShippingStateOption] =
    useState(null);

  const [shippingRecipientName, setShippingRecipientName] = useState(null);
  const [shippingRecipientPhoneNumber, setShippingRecipientPhoneNumber] =
    useState(null);
  const [shippingCity, setShippingCity] = useState(null);
  const [shippingState, setShippingState] = useState(null);
  const [shippingAddress, setShippingAddress] = useState(null);
  const [shippingLatitude, setShippingLatitude] = useState(null);
  const [shippingLongitude, setShippingLongitude] = useState(null);
  const [shippingInformationValues, setShippingInformationValues] =
    useState(null);
  const [cart, setCart] = useState(null);

  useEffect(() => {
    let session = localStorage.getItem(AppConfig.product_cart_storage_label);
    if (session === null) {
      return;
    }
    const xcart = JSON.parse(session);
    setCart(xcart);
    setCurrency(xcart.product.currency);

    let tPrice = xcart.product.quantity * xcart.product.amount;
    setTotalPrice(tPrice);

    let prds = [];
    prds.push(xcart.product);
    setProducts(prds);

    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`checkout/product/campaign/${xcart.agent_reference}/fetch.json`)
        .then((result) => {
          setShowLoading(false);
          console.log(result.data.data);
          if (result.data.status === "success") {
            setBanner(result.data.data.banner);
            setWebStore(result.data.data.webstore);
            setCampaign(result.data.data.campaign);

            // setCurrency(result.data.data.campaign.currency.symbol);
            setCampaignPaymentMethods(result.data.data.payment_methods);
            if (result.data.data.campaign.payment_required) {
              setShowPaymentMethods(true);
            } else {
              setShowPaymentMethods(false);
              setPaymentMethod("FREE");
            }

            if (result.data.data.campaign.data_form !== null) {
              var stepsTemp = steps;
              setSteps(["Required Information", ...stepsTemp]);
              setDataForm(result.data.data.campaign.data_form);
            }

            setShippingRequired(result.data.data.campaign.is_shipping_required);
            if (result.data.data.campaign.shipping_rate !== null) {
              let states = [];
              for (const [key, value] of Object.entries(
                result.data.data.campaign.shipping_rate.rates,
              )) {
                // console.log(key, value);
                states.push({ reference: key, title: value.title });
              }

              setShippingRate(result.data.data.campaign.shipping_rate);
              setShippingStates(states);

              var stepsTemp = steps;
              setSteps(["Shipping Information", ...stepsTemp]);
            }

            let bizName =
              result.data.data.webstore !== null
                ? result.data.data.webstore.title
                : result.data.data.campaign.account.name;
            setPageTitle(`${bizName} | ${result.data.data.campaign.title}`);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine
                ? ""
                : "Make sure you have an active internet connection"
            }`,
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  useEffect(() => {
    setSelectedShippingStateOption(null);
    if (selectedShippingState === null) {
      return;
    }
    setShippingStateOptions(shippingRate.rates[selectedShippingState].options);
  }, [selectedShippingState]);

  const handleNext = () => {
    let stepVal = steps[activeStep];
    if (stepVal.includes("Required")) {
      if (dataForm !== null && activeStep === 0) {
        const validated = preprocessDataForm();
        if (!validated) {
          return;
        }

        setDataFormValues(validated);
        setActiveStep(activeStep + 1);
      }
    } else if (stepVal.includes("Shipping")) {
      const validated = validateShippingInfo();
      if (!validated) {
        return;
      }

      setShippingInformationValues(validated);
      setActiveStep(activeStep + 1);
    } else {
      dispense();
    }
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  function getStepContent(activeStep) {
    let stepVal = steps[activeStep];
    if (stepVal.includes("Required")) {
      if (dataForm !== null && activeStep === 0) {
        return (
          <Box mb={5}>
            <form id="dataForm">
              {dataFormSections.map((section) => (
                <Box mb={5}>
                  <Paper elevation={2}>
                    <Box p={3}>{section}</Box>
                  </Paper>
                </Box>
              ))}
            </form>
          </Box>
        );
      }
    } else if (stepVal.includes("Shipping")) {
      return showShippingForm();
    } else {
      return showPayerInformationForm();
    }
  }

  function showPayerInformationForm() {
    return (
      <Box mb={5}>
        <Paper elevation={2}>
          <Box p={3}>
            <Box>
              <Typography variant="caption" fontWeight="regular">
                PAYER INFORMATION
              </Typography>
              <Box mt={2} mb={2}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6} lg={6}>
                    <TextField
                      name="last_name"
                      margin="dense"
                      label="Last Name"
                      type="text"
                      fullWidth
                      variant="outlined"
                      onChange={(e) => setLastName(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Icon>person</Icon>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <TextField
                      name="first_name"
                      margin="dense"
                      label="First Name"
                      type="text"
                      fullWidth
                      variant="outlined"
                      onChange={(e) => setFirstName(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Icon>person</Icon>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>
              <Box mb={2}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6} lg={6}>
                    <TextField
                      name="email_address"
                      margin="dense"
                      label="Email Address"
                      type="email"
                      fullWidth
                      variant="outlined"
                      onChange={(e) => setEmailAddress(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Icon>email</Icon>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <TextField
                      name="phone_number"
                      margin="dense"
                      label="Phone Number"
                      type="text"
                      fullWidth
                      variant="outlined"
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Icon>phone</Icon>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>
            </Box>
            {showPaymentMethods ? (
              <Box mt={5}>
                <Typography variant="caption" fontWeight="regular">
                  PAYMENT METHOD
                </Typography>
                <Box mt={3}>
                  <TextField
                    fullWidth
                    select
                    label="How do you want to pay?"
                    onChange={(e) => {
                      setPaymentMethod(e.target.value);
                    }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Icon>payment</Icon>
                        </InputAdornment>
                      ),
                    }}
                  >
                    {
                      // --> Notice below changes
                      campaignPaymentMethods.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                        campaignPaymentMethods.map((record) => (
                          <MenuItem key={record.value} value={record.value}>
                            {record.name}
                          </MenuItem>
                        ))
                    }
                  </TextField>
                </Box>
              </Box>
            ) : (
              <> </>
            )}
          </Box>
        </Paper>
      </Box>
    );
  }

  function showShippingForm() {
    return (
      <>
        {shippingRequired ? (
          <Box mt={1} mb={5}>
            <Paper elevation={3}>
              <Box p={3}>
                <Typography variant="caption" fontWeight="regular">
                  SHIPPING INFORMATION
                </Typography>
                <Box mt={2} mb={2}>
                  <Box mb={2}>
                    <TextField
                      name="recipient_name"
                      value={shippingRecipientName}
                      margin="dense"
                      label="Receiver's Name"
                      type="text"
                      fullWidth
                      variant="outlined"
                      onChange={(e) => setShippingRecipientName(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Icon>person</Icon>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                  <Box mb={2}>
                    <TextField
                      name="phone_number"
                      value={shippingRecipientPhoneNumber}
                      margin="dense"
                      label="Receiver's Phone Number"
                      type="text"
                      fullWidth
                      variant="outlined"
                      onChange={(e) =>
                        setShippingRecipientPhoneNumber(e.target.value)
                      }
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Icon>phone</Icon>
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Box>
                  <Box mb={2}>
                    <GoogleAddressField
                      displayName="Receiver's Address"
                      setAddress={setShippingAddress}
                      setLatitude={setShippingLatitude}
                      setLongitude={setShippingLongitude}
                    />
                  </Box>
                  {shippingRate === null ? (
                    <>
                      <Box mb={2}>
                        <TextField
                          name="shipping_city"
                          value={shippingCity}
                          margin="dense"
                          label="Shipping City"
                          type="text"
                          fullWidth
                          variant="outlined"
                          onChange={(e) => setShippingCity(e.target.value)}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Icon>place</Icon>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Box>
                      <Box mb={2}>
                        <TextField
                          name="shipping_state"
                          value={shippingState}
                          margin="dense"
                          label="Shipping State"
                          type="text"
                          fullWidth
                          variant="outlined"
                          onChange={(e) => setShippingState(e.target.value)}
                          InputProps={{
                            startAdornment: (
                              <InputAdornment position="start">
                                <Icon>explore</Icon>
                              </InputAdornment>
                            ),
                          }}
                        />
                      </Box>
                    </>
                  ) : (
                    <> </>
                  )}
                </Box>
              </Box>
            </Paper>
          </Box>
        ) : (
          <> </>
        )}

        {shippingRate !== null ? (
          <Box mt={5} mb={5}>
            <Paper elevation={3}>
              <Box px={3} py={3}>
                <Typography variant="caption" fontWeight="regular">
                  SHIPPING OPTIONS
                </Typography>
                <Box mt={2} mb={2}>
                  <Box mt={5} mb={3}>
                    <Box mt={3}>
                      <TextField
                        value={selectedShippingState}
                        fullWidth
                        select
                        label="Select State"
                        onChange={(e) => {
                          setSelectedShippingState(e.target.value);
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Icon>explore</Icon>
                            </InputAdornment>
                          ),
                        }}
                      >
                        {
                          // --> Notice below changes
                          shippingStates.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                            shippingStates.map((record) => (
                              <MenuItem
                                key={record.reference}
                                value={record.reference}
                              >
                                {record.title}
                              </MenuItem>
                            ))
                        }
                      </TextField>
                    </Box>
                    <Box mt={5}>
                      <TextField
                        value={selectedShippingStateOption}
                        fullWidth
                        select
                        label="Select Location"
                        onChange={(e) => {
                          setSelectedShippingStateOption(e.target.value);
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Icon>place</Icon>
                            </InputAdornment>
                          ),
                        }}
                      >
                        {
                          // --> Notice below changes
                          shippingStateOptions.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                            shippingStateOptions.map((record) => (
                              <MenuItem
                                key={record.reference}
                                value={record.reference}
                              >
                                <Typography
                                  variant="caption"
                                  fontWeight={500}
                                  fontSize={14}
                                >
                                  {record.title}
                                  <br />
                                  <b>
                                    Shipping Fee:&nbsp;
                                    {currency.symbol}
                                    {(record.amount / 100).toLocaleString(
                                      "en",
                                      {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      },
                                    )}
                                  </b>
                                </Typography>
                              </MenuItem>
                            ))
                        }
                      </TextField>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </Paper>
          </Box>
        ) : (
          <> </>
        )}
      </>
    );
  }

  useEffect(() => {
    const sections = [];
    if (dataForm === null) {
      return;
    }

    dataForm.form.form.sections.every(async (param) => {
      // console.log(param);
      const sect = <FormSectionBuilder section={param} />;
      sections.push(sect);
      return false;
    });
    // console.log(sections);
    setDataFormSections(sections);
  }, [dataForm]);

  const { coords, isGeolocationAvailable, isGeolocationEnabled } =
    useGeolocated({
      positionOptions: {
        enableHighAccuracy: true,
      },
      userDecisionTimeout: 5000,
    });

  function getGPSCoords() {
    if (!isGeolocationAvailable) {
      return false;
    }

    if (!isGeolocationEnabled) {
      return false;
    }

    if (coords) {
      return { latitude: coords.latitude, longitude: coords.longitude };
    }

    return false;
  }

  function getFormFieldDisplayName(fieldRef) {
    if (dataForm === null) {
      return "Unknown field";
    }

    let dName = "";
    dataForm.form.form.sections.every((section) => {
      section.fields.every((field) => {
        if (field.reference === fieldRef) {
          dName = `${field.display_name} (${section.title})`;
        }
        return true;
      });
      return true;
    });

    return dName ? dName : false;
  }

  function preprocessDataForm() {
    /* eslint-disable no-restricted-syntax */

    const dForm = document.querySelector(`#dataForm`);
    const data = new FormData(dForm);

    for (const entry of data.entries()) {
      if (entry[1].length <= 0) {
        setSeverity("error");
        const dF_fieldName = getFormFieldDisplayName(entry[0]);
        if (dF_fieldName === false) {
          continue;
        }
        setErrMsg(`${dF_fieldName} is required`);
        setOpen(true);
        return false;
      }
    }

    const values = Object.fromEntries(data.entries());
    return values;
  }

  function validateShippingInfo() {
    if (shippingRequired) {
      if (shippingRecipientName === null || shippingRecipientName.length < 3) {
        setSeverity("error");
        setErrMsg("Shipping receiver's name required");
        setOpen(true);
        return false;
      }

      if (
        shippingRecipientPhoneNumber === null ||
        shippingRecipientPhoneNumber.length < 3
      ) {
        setSeverity("error");
        setErrMsg("Shipping receiver's phone number required");
        setOpen(true);
        return false;
      }

      if (
        shippingAddress === null ||
        shippingLatitude === null ||
        shippingLongitude === null
      ) {
        setSeverity("error");
        setErrMsg("Shipping address required");
        setOpen(true);
        return false;
      }

      if (shippingRate === null) {
        if (shippingCity === null || shippingCity.length < 3) {
          setSeverity("error");
          setErrMsg("Shipping city required");
          setOpen(true);
          return false;
        }

        if (shippingState === null || shippingState.length < 3) {
          setSeverity("error");
          setErrMsg("Shipping state required");
          setOpen(true);
          return false;
        }
      }
    }

    if (shippingRate !== null) {
      if (
        selectedShippingState === null ||
        selectedShippingStateOption === null
      ) {
        setSeverity("error");
        setErrMsg("Please select your shipping location");
        setOpen(true);
        return false;
      }

      return {
        reference: shippingRate.reference,
        state: selectedShippingState,
        option: selectedShippingStateOption,
      };
    }
    return null;
  }

  async function dispense() {
    const gpsCoords = getGPSCoords();
    // console.log(gpsCoords);
    // if (!gpsCoords) {
    //   setSeverity("error");
    //   setErrMsg("Please enable and allow browser's location and GPS access.");
    //   setOpen(true);
    //   return;
    // }

    if (dataForm !== null) {
      if (dataFormValues === false) {
        return;
      }
      // console.log(dataFormValues);
    }

    if (shippingRequired) {
      if (shippingInformationValues === false) {
        return;
      }
      // console.log(shippingInformationValues);
    }

    if (firstName === null) {
      setSeverity("error");
      setErrMsg("Customer first name required");
      setOpen(true);
      return;
    }

    if (lastName === null) {
      setSeverity("error");
      setErrMsg("Customer last name required");
      setOpen(true);
      return;
    }

    if (emailAddress === null) {
      setSeverity("error");
      setErrMsg("Customer email address required");
      setOpen(true);
      return;
    }

    if (phoneNumber === null) {
      setSeverity("error");
      setErrMsg("Customer phone number required");
      setOpen(true);
      return;
    }

    if (paymentMethod === null) {
      setSeverity("error");
      setErrMsg("Payment method required.");
      setOpen(true);
      return;
    }

    if (window.confirm("Are you sure you want to proceed?") === false) {
      return;
    }

    setShowLoading(true);
    const json = {
      reference: cart.agent_reference,
      products: products,
      payment_method: paymentMethod,
      customer: {
        first_name: firstName,
        last_name: lastName,
        email_address: emailAddress,
        phone_number: phoneNumber,
        // mobile_network: `${network}`,
      },
      campaign: `${campaign}`,
      latitude: gpsCoords ? gpsCoords.latitude : null,
      longitude: gpsCoords ? gpsCoords.longitude : null,
      data_form: dataForm !== null ? dataFormValues : null,
      shipping_option: shippingInformationValues,
      shipping_info: {
        name: shippingRecipientName,
        phone_number: shippingRecipientPhoneNumber,
        address: shippingAddress,
        latitude: shippingLatitude,
        longitude: shippingLongitude,
        state: shippingState,
        city: shippingCity,
      },
    };

    // console.log(json);

    await axios
      .post("checkout/campaign/checkout.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          window.location.href = result.data.data.redirect_url;
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg(
          `Unable to complete request. ${
            navigator.onLine
              ? ""
              : "Make sure you have an active internet connection"
          }`,
        );
        setOpen(true);
      });
  }

  return (
    <>
      <Box mb={10}>
        <Container>
          <Backdrop
            sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={showLoading}
            onClick={handleClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Snackbar
            open={open}
            autoHideDuration={6000}
            onClose={handleClose}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert
              onClose={handleClose}
              severity={severity}
              sx={{ width: "100%" }}
            >
              {errorMsg}
            </Alert>
          </Snackbar>
          <Box>
            <Grid container>
              <Grid
                item
                xs={12}
                sm={12}
                lg={4}
                sx={{
                  display: { xs: "flex", sm: "flex", md: "flex" },
                  flexDirection: "column",
                  backgroundColor: "background.paper",
                  borderRight: { sm: "none", md: "1px solid" },
                  borderColor: { sm: "none", md: "divider" },
                  alignItems: "start",
                  pt: { xs: -4, md: 4 },
                  px: { xs: 1, sm: 3 },
                  gap: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    mt: { xs: 3, md: 15 },
                  }}
                >
                  <Button
                    startIcon={<Icon>arrow_back_rounded</Icon>}
                    sx={{ ml: "-8px" }}
                    onClick={() => {
                      window.history.back();
                    }}
                  >
                    Back
                  </Button>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    flexGrow: 1,
                    width: "100%",
                    // maxWidth: 500,
                  }}
                  mt={3}
                >
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary">
                      Total
                    </Typography>
                    <Typography variant="h5" gutterBottom>
                      <small>{currency}</small>
                      {(totalPrice / 100).toLocaleString("en", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })}
                    </Typography>
                  </Box>
                  <Box mt={1}>
                    <Divider />
                  </Box>
                  {products.length > 0 ? (
                    <Box mt={2}>
                      <List disablePadding>
                        {products.map((product) => (
                          <Box>
                            <ListItem
                              key={product.reference}
                              sx={{ py: 1, px: 0 }}
                            >
                              <ListItemIcon>
                                <img
                                  src={`${AppConfig.api_media_url}${product.image}`}
                                  //alt={product.name}
                                  alt=""
                                  width="48px"
                                />
                              </ListItemIcon>
                              <ListItemText
                                sx={{ mr: 2 }}
                                primary={
                                  <Typography fontSize={13}>
                                    {product.name}
                                  </Typography>
                                }
                                secondary={
                                  <Typography fontSize={10} fontWeight={100}>
                                    {`Quantity: ${product.quantity}`}
                                  </Typography>
                                }
                              />
                              <Box>
                                <Box mt={-1.5}>
                                  <Typography
                                    variant="body1"
                                    fontWeight="medium"
                                  >
                                    <small>{currency}</small>
                                    {(
                                      (product.amount * product.quantity) /
                                      100
                                    ).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </Typography>
                                </Box>
                              </Box>
                            </ListItem>
                            <Box mt={1}>
                              <Typography fontSize={10} fontWeight={100}>
                                {product.variants.map((variant) => (
                                  <>
                                    {variant.variant_title}
                                    :&nbsp;{variant.option_title}
                                    &nbsp;|&nbsp;
                                  </>
                                ))}
                              </Typography>
                            </Box>
                          </Box>
                        ))}
                      </List>
                    </Box>
                  ) : (
                    <> </>
                  )}
                </Box>
              </Grid>
              <Grid
                item
                sm={12}
                md={7}
                lg={8}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  maxWidth: "100%",
                  width: "100%",
                  backgroundColor: {
                    xs: "transparent",
                    sm: "background.default",
                  },
                  alignItems: "start",
                  pt: { xs: 2, sm: 4 },
                  px: { sm: 10 },
                  gap: { xs: 4, md: 8 },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: { sm: "space-between", md: "flex-end" },
                    alignItems: "center",
                    width: "100%",
                    maxWidth: { sm: "100%", md: 600 },
                  }}
                >
                  <Box
                    sx={{
                      display: { xs: "none", md: "flex" },
                      flexDirection: "column",
                      justifyContent: "space-between",
                      alignItems: "flex-end",
                      flexGrow: 1,
                      height: 150,
                    }}
                  >
                    <Icon color="primary">receipt</Icon>
                    <Stepper
                      id="desktop-stepper"
                      activeStep={activeStep}
                      sx={{
                        width: "100%",
                        height: 40,
                      }}
                    >
                      {steps.map((label) => (
                        <Step
                          sx={{
                            ":first-child": { pl: 0 },
                            ":last-child": { pr: 0 },
                          }}
                          key={label}
                        >
                          <StepLabel>{label}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    flexGrow: 1,
                    width: "100%",
                    // maxWidth: { sm: "100%", md: 600 },
                    // maxHeight: "720px",
                    gap: { xs: 5, md: "none" },
                  }}
                >
                  <Stepper
                    id="mobile-stepper"
                    activeStep={activeStep}
                    alternativeLabel
                    sx={{ display: { sm: "flex", md: "none" }, mt: { xs: 0 } }}
                  >
                    {steps.map((label) => (
                      <Step
                        sx={{
                          ":first-child": { pl: 0 },
                          ":last-child": { pr: 0 },
                          "& .MuiStepConnector-root": {
                            top: { xs: 12, sm: 12 },
                          },
                        }}
                        key={label}
                      >
                        <StepLabel
                          sx={{
                            ".MuiStepLabel-labelContainer": {
                              maxWidth: "70px",
                            },
                          }}
                        >
                          {label}
                        </StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                  {activeStep === steps.length ? (
                    <Stack spacing={2} useFlexGap>
                      <Typography variant="h1">📦</Typography>
                      <Typography variant="h5">
                        Thank you for your order!
                      </Typography>
                      <Typography variant="body1" color="text.secondary">
                        Your order number is
                        <strong>&nbsp;#140396</strong>. We have emailed your
                        order confirmation and will update you once its shipped.
                      </Typography>
                      <Button
                        variant="contained"
                        sx={{
                          alignSelf: "start",
                          width: { xs: "100%", sm: "auto" },
                        }}
                      >
                        Go to my orders
                      </Button>
                    </Stack>
                  ) : (
                    <>
                      <Container>
                        {getStepContent(activeStep)}
                        <Box mt={10} mb={5}>
                          <Grid container spacing={3}>
                            <Grid item xs={6}>
                              <Box align="left">
                                {activeStep !== 0 && (
                                  <Button
                                    startIcon={<Icon>chevron_left</Icon>}
                                    onClick={handleBack}
                                    variant="outlined"
                                  >
                                    Previous
                                  </Button>
                                )}
                              </Box>
                            </Grid>
                            <Grid item xs={6}>
                              <Box align="right">
                                <Button
                                  xs={6}
                                  variant="contained"
                                  endIcon={
                                    <Icon>
                                      {activeStep === steps.length - 2
                                        ? "payment"
                                        : "chevron_right"}
                                    </Icon>
                                  }
                                  onClick={handleNext}
                                >
                                  {activeStep === steps.length - 2
                                    ? "Pay"
                                    : "Next"}
                                </Button>
                              </Box>
                            </Grid>
                          </Grid>
                        </Box>
                      </Container>
                    </>
                  )}
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Box>
      <CheckoutFooter />
    </>
  );
}

export default BuyPage;
